import React from "react";
import { CountdownTimer } from "./Timer";

function Registry() {
  return (
    <section id="registry-timer">
      <section className="elegant-registry-section py-5 registry">
        <div className="container d-flex justify-content-center">
          <div className="elegant-registry-card text-center">
            <h3 className="elegant-registry-heading">REGISTRY</h3>

            <h3 className="elegant-registry-subtitle">
              Your love and presence on our wedding day mean everything to us.
            </h3>

            <p className="elegant-registry-text">
              For those who have asked, we’ve created a small Amazon registry
              with a few meaningful items.
            </p>

            <p className="elegant-registry-text">
              We’re so thankful to celebrate this special time with you!
            </p>

            <a
              href="https://www.amazon.ca/wedding/registry/306U07WU0EU9N"
              target="_blank"
              rel="noopener noreferrer"
              className="elegant-registry-button"
            >
              View Registry
            </a>
          </div>
        </div>
      </section>
      <CountdownTimer />
    </section>
  );
}

export default Registry;
